var map = {
	"./fino.png": 646,
	"./fino2.png": 7238,
	"./fino3.png": 3567,
	"./normal.png": 5413,
	"./normal2.png": 4483,
	"./normal3.png": 2906,
	"./normal4.png": 7205,
	"./sério.png": 9716,
	"./sério2.png": 2348,
	"./sério3.png": 7794,
	"./zoião.png": 8726,
	"./zoião2.png": 2182,
	"./zoião3.png": 3727,
	"./zoião4.png": 8352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 681;